export enum PermissionsList {
  ClientHomeView = 206,
  ClientHomeCreate = 207,
  ClientHomeEdit = 208,
  ClientHomeDelete = 209,
  ClientHomeArchive = 210,

  ClientClientInvoicesView = 211,
  ClientClientInvoicesCreate = 212,
  ClientClientInvoicesEdit = 213,
  ClientClientInvoicesDelete = 214,
  ClientClientInvoicesArchive = 215,

  RideBlueprintView = 216,
  RideBlueprintCreate = 217,
  RideBlueprintEdit = 218,
  RideBlueprintDelete = 219,
  RideBlueprintArchive = 220,

  RideMonitorView = 221,
  RideMonitorCreate = 222,
  RideMonitorEdit = 223,
  RideMonitorDelete = 224,
  RideMonitorArchive = 225,

  ClientStudentsView = 226,
  ClientStudentsCreate = 227,
  ClientStudentsEdit = 228,
  ClientStudentsDelete = 229,
  ClientStudentsArchive = 230,

  ClientNoShowReportView = 231,
  ClientNoShowReportEdit = 233,
  ClientNoShowReportDelete = 234,
  ClientNoShowReportArchive = 235,

  ClientRideFinderReportView = 396,
  ClientRideFinderReportCreate = 397,
  ClientRideFinderReportEdit = 398,
  ClientRideFinderReportDelete = 399,
  ClientRideFinderReportArchive = 400,

  ClientPlacesView = 482,
  ClientPlacesCreate = 483,
  ClientPlacesEdit = 484,
  ClientPlacesDelete = 485,
  ClientPlacesArchive = 486,

  ClientGuardiansView = 487,
  ClientGuardiansCreate = 488,
  ClientGuardiansEdit = 489,
  ClientGuardiansDelete = 490,
  ClientGuardiansArchive = 491,

  ClientConsecutiveNoShowReportView = 492,
  ClientConsecutiveNoShowReportCreate = 493,
  ClientConsecutiveNoShowReportEdit = 494,
  ClientConsecutiveNoShowReportDelete = 495,
  ClientConsecutiveNoShowReportArchive = 496,
}
